const LEAGUE_LOGOS: Record<string, string> = {
  "الدوري المصري الممتاز": "/manus-storage/233_3b6d412d.png",
  "الدوري السعودي للمحترفين": "/manus-storage/307_7163d9b1.png",
  "الدوري الإماراتي للمحترفين": "/manus-storage/301_933cd93c.png",
  "الدوري الإسباني": "/manus-storage/140_2ed7e3f8.png",
  "الدوري الإنجليزي الممتاز": "/manus-storage/39_3c0284aa.png",
  "الدوري التركي الممتاز": "/manus-storage/203_df487e30.png",
  "الدوري الفرنسي": "/manus-storage/61_425d9e14.png",
  "دوري نجوم قطر": "/manus-storage/305_e6982263.png",
};

export function getLeagueLogo(name?: string | null) {
  return name ? LEAGUE_LOGOS[name] ?? null : null;
}

export { LEAGUE_LOGOS };
